import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';
import Reveal from '@/components/Reveal';

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page">
      <section className="mm-section" style={{ paddingTop: 72 }}>
        <div className="container-mm">
          <div className="eyebrow">{t.nav.about}</div>
          <h1 style={{ fontSize: 'clamp(48px, 6vw, 96px)', marginTop: 16, maxWidth: 900 }}>
            {t.home.about_title}
          </h1>
          <p style={{ fontSize: 18, color: 'var(--mm-slate)', marginTop: 24, maxWidth: 720 }}>
            {t.home.about_lead}
          </p>
        </div>
      </section>

      <section className="mm-section alabaster" style={{ paddingTop: 48 }}>
        <div className="container-mm">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 40 }}>
            <Reveal>
              <div className="mm-geo-visual" style={{ aspectRatio: '3/4' }}>
                <img src="https://images.unsplash.com/photo-1587854692152-cbe660dbde88?auto=format&fit=crop&w=1000&q=70" alt="laboratory" />
              </div>
            </Reveal>
            <Reveal delay={100}>
              <div className="eyebrow">MISSION</div>
              <h2 style={{ marginTop: 12 }}>{t.hero.title_a} <em style={{ color: 'var(--mm-emerald)', fontStyle: 'italic' }}>{t.hero.title_b}</em> — {t.hero.title_c.toLowerCase()}</h2>
              <div style={{ height: 24 }} />
              <p style={{ color: 'var(--mm-slate)', fontSize: 17 }}>
                МЕД МИР — независимый оператор с 2018 года. Наша команда объединяет фармацевтов, регуляторных специалистов, медицинских представителей и логистов. Все процессы построены вокруг одной ценности: качественное лекарство должно доходить до пациента вовремя и в неизменном виде.
              </p>
              <div style={{ height: 24 }} />
              <Link to="/contacts" className="btn btn-primary" data-testid="about-cta">
                {t.common.become_partner} <ArrowUpRight size={16} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
